import { useCallback } from 'react'
import { IOpenPanel } from '../../../../../Interfaces/IPanel'
import {IRazonModeloDTO } from '../../../../../Interfaces/auxiliar/IRazonModelo'
import { Label, Panel } from '@fluentui/react'
import { MessageBarResponse } from '../../../../../components/MessageBarResponse/MessageBarResponse'
import { ProgressBarLoading } from '../../../../../components/ProgressBarLoading/ProgressBarLoading'
import { UseRazonModeloEliminar } from './UseRazonModeloEliminar'
import { PanelHeader } from '../../../../../components/Panel/PanelHeader'
import { PanelFooter } from '../../../../../components/Panel/PanelFooter'
import { Body1, makeStyles } from "@fluentui/react-components";
import { Warning24Filled } from "@fluentui/react-icons";
export interface IPanelRazonModeloEliminar extends IOpenPanel {
   item: IRazonModeloDTO
}

const PanelRazonModeloEliminar = (props: IPanelRazonModeloEliminar) => {
   const styles = useStyles();
   const { request, setRequest, deleteRazonModelo, loading, reset, mensaje, status, loadprogress, contentShow } = UseRazonModeloEliminar(props)

   const onRenderHeader = useCallback(
      () => (
         <PanelHeader
            textHeader={"Eliminar Razón Modelo"}
            // subTextHeader={`Eliminar Razón Modelo`}
         />
      ),
      []
   );

   const onRenderFooter = useCallback(
      () => (
         <>
            <PanelFooter
               texto="Eliminar"
               onClick={deleteRazonModelo}
               onDismiss={reset}
            />
         </>
      ),
      [request]
   );

   return (
      <Panel
         isOpen={props.isOpen}
         onDismiss={reset}
         isFooterAtBottom
         onRenderHeader={onRenderHeader}
         onRenderFooter={onRenderFooter}
      >
         <div hidden={mensaje == ""}>
            <MessageBarResponse
               objetoResponse={{ codigo: status, mensaje: mensaje }}
               close={true}
            />
         </div>
         <div hidden={!loading}>
            <ProgressBarLoading></ProgressBarLoading>
         </div>
         <div hidden={loading}>
            {!mensaje && (
               <>
                  {!loadprogress && (
                     <>
                        {contentShow && (
                           <>
                              <div className={styles.container}>
                                 <div>
                                    <Warning24Filled className={styles.warning} />
                                 </div>
                                 <div>
                                    <Body1>
                                       Esta Razón será eliminada permanentemente, ¿Desea
                                       eliminar la Razón: {props.item.nombre}?
                                    </Body1>
                                 </div>
                              </div>
                           </>
                        )}
                     </>
                  )}
               </>
            )}
         </div>

      </Panel>
   )
}

export { PanelRazonModeloEliminar }
const useStyles = makeStyles({
   container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      top: "100%",
      alignItems: "center",
   },

   warning: {
      color: " #eaa300",
      width: "60px",
      height: "60px",
   },
});